<nz-spin [nzSpinning]="loading" [nzTip]="loadMsg">
<form [formGroup]="form"   nz-form [nzLayout]="'vertical'">
<div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
<div class="col" style="flex: 1 1 45%">
  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="payment_date">Payment Date</nz-form-label>
    <nz-form-control nzErrorTip="Payment date is required">
      <nz-date-picker formControlName="payment_date" name="payment_date" style="width: 100%;"></nz-date-picker>
    </nz-form-control>
  </nz-form-item>
  <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap"> 
   <div style="flex: 1 1 45%"> 
    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="amount_paid">Amount Paid</nz-form-label>
      <nz-form-control nzErrorTip="Amount is required">
        <input nz-input type="number" name="amount_paid" formControlName="amount_paid" />
      </nz-form-control>
    </nz-form-item>
  </div>
  <div style="flex: 1 1 45%"> 
  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="payment_method">Payment Method</nz-form-label>
    <nz-form-control nzErrorTip="Payment method is required">
      <nz-select nzShowSearch nzAllowClear formControlName="payment_method" name="payment_method" nzPlaceHolder="Select an invoice">
        <nz-option *ngFor="let pay of paymentMethods" [nzValue]="pay.id" [nzLabel]="pay.name"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  </div>
  </div>
  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="invoice">Invoice</nz-form-label>
    <nz-form-control nzErrorTip="Invoice is required">
      <nz-select nzShowSearch nzAllowClear formControlName="invoice" name="invoice" nzPlaceHolder="Select an invoice">
        <nz-option *ngFor="let inv of invoices" [nzValue]="inv.id" [nzLabel]="inv.invoice_number"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
      <nz-form-label >Files</nz-form-label>
      <nz-form-control  >
        <nz-upload class="w-100" [nzSize]="5242880"
         [nzCustomRequest]="customUploadRequest"
          nzListType="picture"  [nzBeforeUpload]="beforeUpload"
          (nzChange)="onUploadChange($event)"
          [(nzFileList)]="fileList">
          <button nz-button>
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button>
        </nz-upload>
      </nz-form-control>
    </nz-form-item>  
</div>
<div class="col" style="flex: 1 1 45%">
  <nz-form-item>
    <nz-form-label nzFor="transaction_id">Transaction ID</nz-form-label>
    <nz-form-control>
      <input nz-input formControlName="transaction_id" name="transaction_id" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzFor="notes">Notes</nz-form-label>
    <nz-form-control>
      <textarea nz-input formControlName="notes" name="notes" rows="5"></textarea>
    </nz-form-control>
  </nz-form-item>

  
<!-- 
  <nz-form-item>
    <nz-form-label nzFor="recorded_by">Recorded By</nz-form-label>
    <nz-form-control>
      <nz-select formControlName="recorded_by" name="recorded_by" nzPlaceHolder="Select a user">
        <nz-option *ngFor="let user of users" [nzValue]="user.id" [nzLabel]="user.name"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item> -->



  <button style="float: inline-end;" nz-button nzType="primary" (click)="onSubmit()" [disabled]="form.invalid"> {{ payment?.data?.id ? 'Update' : 'Create'}} </button>
</div>
</div>
</form>
</nz-spin>